module.exports = __webpack_public_path__ + "img/swiper3.b546a7b2.jpg";